export default defineNuxtRouteMiddleware((to) => {
  if (to.query.social_auth_success === "1" && to.query.provider) {
    try {
      const { sendEvent } = useAnalytics();

      sendEvent("site_sign_up_completed", {
        auth_provider_name: to.query.provider as string,
      });
    } catch (error) {
      console.error("Analytics error:", error);
    }

    const router = useRouter();
    const cleanQuery = { ...to.query };
    delete cleanQuery.social_auth_success;
    delete cleanQuery.provider;

    router.replace({
      path: to.path,
      query: cleanQuery,
    });
  }
});
